import { defineComponent as _defineComponent } from 'vue'


type Props = {
  title: string;
  resource: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    title: null,
    resource: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  resource: any;
}



const fields = [
  {
    source: 'id',
    link: 'edit',
    sortable: false,
  },
  {
    source: 'name',
    label: 'Name',
    sortable: true,
  },
  {
    source: 'categoryId',
    type: 'reference',
    attributes: {
      reference: 'categories',
    },
  },
  {
    source: 'slug',
    label: 'Slug',
    sortable: true,
  },
  {
    source: 'active',
    type: 'boolean',
    sortable: true,
  },
  {
    source: 'order',
    label: 'Order within category',
    sortable: true,
  },
];

return { __sfc: true,props, fields }
}

})